import urlJoin from "url-join";

export const atticAssetsSectionUrlName = "/attic/digital-assets";

export const atticAssetDirectoryListPath = `${atticAssetsSectionUrlName}/`;
export const atticAssetDirectoryPath = (id: string) => urlJoin(atticAssetDirectoryListPath, id);
export const atticAssetDirectoryUrl = (id: string) =>
  atticAssetDirectoryPath(encodeURIComponent(id));
